'use client';

import { FC, ReactNode } from 'react';
import dynamic from 'next/dynamic';

// Dynamically load contact links to avoid SSR hydration issues
const SidebarContactLinks = dynamic(
  () => import('./SidebarContactLinks'),
  { 
    ssr: false,
    loading: () => (
      <div className="mt-6 min-h-[400px] animate-pulse bg-gray-100 dark:bg-gray-800 rounded-lg" />
    ),
  }
);

interface SidebarProps {
  children?: ReactNode;
}

const Sidebar: FC<SidebarProps> = ({ children }) => {
  return (
    <aside className="sticky top-0 w-full md:w-64 h-screen p-6 bg-white dark:bg-gray-900 border-r dark:border-gray-800 overflow-y-auto flex flex-col">
      
      {/* Branding / Name */}
      <div className="mb-6 text-xl font-bold text-gray-800 dark:text-white">
        Eric Agyei
      </div>

      {/* Contact Links */}
      <SidebarContactLinks />

      {/* Extra Children (e.g., Upcoming card or other widgets) */}
      {children && <div className="mt-8 flex flex-col gap-6">{children}</div>}
    </aside>
  );
};

export default Sidebar;
